import axios from 'axios'
import resolveRequest from '../../utils/resolveRequest.js'
import { apiEndpoints, SERVER_PATH } from '../endpoints'

export default async (id, requestBody) => {
  const endpoint = `${apiEndpoints.dashboardUsers}/${id}/notification-settings`
  const URL = SERVER_PATH + endpoint
  return resolveRequest(axios.put(URL, requestBody, { withCredentials: true }))
}
